import z from 'zod';
export const FISCAL_REGION_METROPOLITAN_FRANCE = 'metropolitan_france';
export const FISCAL_REGION_GUADELOUPE = 'guadeloupe';
export const FISCAL_REGION_GUYANE = 'guyane';
export const FISCAL_REGION_LA_REUNION = 'la_reunion';
export const FISCAL_REGION_MARTINIQUE = 'martinique';
export const FISCAL_REGION_MAYOTTE = 'mayotte';
export const FISCAL_REGION_SAINT_BARTHELEMY = 'saint_barthelemy';
export const FISCAL_REGION_SAINT_MARTIN = 'saint_martin';
export const fiscalRegionValue = z.enum([
    FISCAL_REGION_GUADELOUPE,
    FISCAL_REGION_GUYANE,
    FISCAL_REGION_LA_REUNION,
    FISCAL_REGION_MARTINIQUE,
    FISCAL_REGION_MAYOTTE,
    FISCAL_REGION_METROPOLITAN_FRANCE,
    FISCAL_REGION_SAINT_BARTHELEMY,
    FISCAL_REGION_SAINT_MARTIN,
]);
export const createFiscalRegion = (value) => fiscalRegionValue.parse(value);
export const isFiscalRegion = (value) => fiscalRegionValue.safeParse(value).success;
//# sourceMappingURL=fiscal-region.js.map